import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/colors';

const Breadcrumb = ({ setSelectedItem, selectedItem, isCreatePlan, setIsCreatePlan }) => (
  <div className="breadcrumb-container" style={{ color: colors.white }}>
    <button
      className="breadcrumb-item"
      style={{
        color: !selectedItem && !isCreatePlan ? colors.white : colors.blueThree
      }}
      onClick={() => {
        setSelectedItem(null);
        setIsCreatePlan(false);
      }}
    >
      Plans
    </button>
    {!!selectedItem && (
      <>
        <Icon name="chevron right" />
        <span className="breadcrumb-item">{selectedItem.name}</span>
      </>
    )}
    {isCreatePlan && (
      <>
        <Icon name="chevron right" />
        <span className="breadcrumb-item">New Plan</span>
      </>
    )}
  </div>
);

Breadcrumb.defaultProps = {
  selectedItem: null
};

Breadcrumb.propTypes = {
  setSelectedItem: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  isCreatePlan: PropTypes.bool.isRequired,
  setIsCreatePlan: PropTypes.func.isRequired
};

export default Breadcrumb;
